import { render, staticRenderFns } from "./AttendanceStudentList.vue?vue&type=template&id=5281cf60"
import script from "@/controllers/custom/attendance_student/attendance-student-list.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/attendance_student/attendance-student-list.js?vue&type=script&lang=js&external"
import style0 from "./AttendanceStudentList.vue?vue&type=style&index=0&id=5281cf60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports